import { useEffect } from "react";
import { toast } from "sonner";

const bundleOf = (html) => (html.match(/\/static\/js\/main\.[\w]+\.js/) || [])[0];

export function UpdateNotice() {
  useEffect(() => {
    const current = [...document.scripts].map((s) => s.src).find((s) => /\/static\/js\/main\.[\w]+\.js/.test(s));
    if (!current) return undefined;
    let shown = false;
    const check = async () => {
      if (shown || document.visibilityState !== "visible") return;
      try {
        const latest = bundleOf(await (await fetch(`/?v=${Date.now()}`, { cache: "no-store" })).text());
        if (latest && !current.endsWith(latest)) {
          shown = true;
          toast("È disponibile una nuova versione dell'app", { duration: Infinity, action: { label: "Aggiorna", onClick: () => window.location.reload() } });
        }
      } catch {}
    };
    const id = setInterval(check, 5 * 60 * 1000);
    document.addEventListener("visibilitychange", check);
    check();
    return () => { clearInterval(id); document.removeEventListener("visibilitychange", check); };
  }, []);
  return null;
}
